<template>
  <div>
    <el-button v-bind="$attrs" type="success" icon="el-icon-download" @click="handleDownload" :loading="downloadLoading">导出Excel</el-button>
    <el-button
      v-show="hasAll"
      v-bind="$attrs"
      type="success"
      icon="el-icon-download"
      @click="handleLoadingAll"
      :loading="downloadLoading"
    >导出全部Execl</el-button>
  </div>
</template>

<script>
import f from '@/filter'

export default {
  name: 'ExportExcel',
  props: {
    data: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    filename: {
      type: String,
      default: ''
    },
    hasAll: {
      type: Boolean,
      default: false
    },
    getAllData: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      downloadLoading: false
    }
  },
  methods: {
    handleDownload (tableData = this.data) {
      this.downloadLoading = true
      import('@/common/Export2Excel').then(excel => {
        const tHeader = []
        const filterVal = []
        for (let h of this.headers) {
          tHeader.push(h.label)
          filterVal.push(h.value)
        }
        const list = tableData
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },
    handleLoadingAll () {
      if (this.getAllData) {
        this.downloadLoading = true
        this.getAllData().then(data => {
          this.handleDownload(data)
          console.log('data', data)
        }).catch(() => {
          this.downloadLoading = false
        })
      }
    },
    formatJson (filterVal, jsonData) {
      let data = jsonData.map(v => {
        return filterVal.map(j => {
          if (v.data) {
            return f.autoFormat(j, v.data[j])
          } else {
            return f.autoFormat(j, v[j])
          }
        })
      })
      return data
    }
  }
}
</script>

<style scoped>

</style>
